import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Table } from "antd";
import { UsePostRequest } from "../../utils/api/ApiRequests";
import moment from "moment";
import { getIsAdminLogin, getEmployeeId } from "../../utils/Common";
import * as XLSX from "xlsx";

export default function LeaveCredit() {
  const isAdminLogin = getIsAdminLogin();
  const employeeId = getEmployeeId();
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [tableColumn, setTableColumn] = useState([]);

  const [filterConfig, setFilterConfig] = useState({
    is_updated: false,
    employee_id: isAdminLogin ? "" : employeeId,
    leave_type_id: "16", //changeable, USED 16 FOR PTO's only
  });

  //   Dynamic table columns because leave types are dynamic as well
  const tableColumns = tableColumn.map((data) => {
    return {
      title: data,
      key: data,
      dataIndex: data,
    };
  });

  const handleSearch = (e) => {
    setFilterConfig((prev) => ({ ...prev, term: e }));
  };

  function exportToExcel() {
    const excelData = [tableColumns.map((col) => col.title)]; // insert header titles first
    // populate excel data
    tableData.forEach((data) => {
      let tempArray = tableColumns.map((col) => data[col.key]);
      excelData.push(tempArray);
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBlob = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: "application/octet-stream" },
    );
    const excelUrl = URL.createObjectURL(excelBlob);
    const downloadAnchor = document.createElement("a");
    downloadAnchor.href = excelUrl;
    downloadAnchor.download = "Employee Leave.xlsx";
    downloadAnchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(excelUrl);
    }, 100);
  }

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UsePostRequest("leave_credits/get", filterConfig);
      if (response.data) {
        const res = response.data;

        // Define headers
        const headers = ["Employee", "Period"];
        res.forEach((data) => {
          var headerName = `${data.description} (${data.maximum_days})`;
          headers.push(headerName);
          // return headerName;
        });

        res.forEach((data, index) => {
          console.log(
            `🔍 Employee Leaves for data[${index}] (ID: ${data.id}):`,
            data.employee_leaves,
          );
        });

        // Flatten and format data
        const mergedArr = res.flatMap((data) =>
          Object.values(data.employee_leaves || [])
            .filter((emp) => typeof emp === "object" && emp !== null) // 🔥 Exclude non-objects
            .map((emp) => ({
              employee_id: emp.employee_id,
              Employee: emp.employee_name || "Unknown",
              Period:
                emp.validity_from && emp.validity_to
                  ? `${moment(emp.validity_from).format("MMM D, YYYY")} - ${moment(emp.validity_to).format("MMM D, YYYY")}`
                  : "N/A",
              [`${data.description} (${data.maximum_days})`]: emp.remaining,
            })),
        );

        // Debug: Check what `mergedArr` contains
        console.log("Merged Array:", mergedArr);

        // Group by employee_id and merge objects
        const mergedObject = mergedArr.reduce((result, obj) => {
          const id = obj.employee_id;
          result[id] = { ...result[id], ...obj };
          return result;
        }, {});

        // Debug: Check if any Employee values are undefined in mergedObject
        console.log("Merged Object Before Sorting:", mergedObject);

        Object.values(mergedObject).forEach((item, index) => {
          if (!item.Employee) {
            console.warn(`⚠️ Undefined Employee at index ${index}:`, item);
          }
        });

        // Sort by employee name with debugging
        const finalArray = Object.values(mergedObject).sort((a, b) => {
          console.log("Comparing:", a.Employee, "vs", b.Employee);
          return (a.Employee || "Unknown").localeCompare(
            b.Employee || "Unknown",
          );
        });

        // Debug: Final sorted array
        console.log("Final Sorted Array:", finalArray);

        if (finalArray.length === 0) {
          setTableData([]);
          setIsFetching(false);
          return;
        }
        const tableCols = Object.keys(finalArray[0]).filter(
          (key) => key !== "employee_id",
        );
        setTableColumn(tableCols);
        setTableData(finalArray);
      }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
      pageTitle="Employee Leave Credits"
      noButton
      setSearchQuery={handleSearch}
      isManager
      searchable={isAdminLogin}
      withYearFilter
      onYearChange={(e) => {
        if (e) {
          setFilterConfig((prev) => ({ ...prev, year: e.$y }));
        } else {
          setFilterConfig((prev) => ({ ...prev, year: null }));
        }
      }}
    >
      <Table
        className="mt-4"
        rowKey="id"
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
      />
    </Navbar>
  );
}
